import { composer } from '../../component-decorators/composer';
import * as React from 'react';
import { ManageInstalledApps, Origin } from '@wix/manage-installed-apps';
import { config } from '../../config';
import { Path } from '../..';
import { useConfigContext } from '../../config-context';
import { getReferralInfo } from '../../common/bi-events';
import { biLogger } from '../../bi';
export var ManageApps = composer()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var marketplaceStore = _a.marketplaceStore, manageAppsDeepLinkData = _a.manageAppsDeepLinkData;
    // tslint:disable-next-line: react-hooks-nesting
    var _b = useConfigContext(), locale = _b.locale, finishAppInstall = _b.finishAppInstall, getAppInstance = _b.getAppInstance, showUserActionNotification = _b.showUserActionNotification, unInstallApp = _b.unInstallApp, openApp = _b.openApp, countryCode = _b.countryCode;
    return (React.createElement(React.Fragment, null,
        React.createElement(ManageInstalledApps, { locale: locale, metasiteId: marketplaceStore.metaSiteId, baseUrl: config.baseApiUrl, origin: Origin.EDITOR, editorUrl: config.editorUrl, manageAppsStaticsUrl: config.manageAppsStaticsUrl, mainButtonAction: config.manageAppsMainButtonAction, getAppInstance: getAppInstance, addAppAgain: finishAppInstall, goToHomePage: function () {
                return config.goto({ path: Path.HOME, referral: 'manage-apps' });
            }, gotoWebSolutionPage: function (slug, referrer, impressionid, referralSectionName) {
                return config.goto({ path: Path.WEB_SOLUTION, slug: slug, referral: referrer, collimp_id: impressionid, referralSectionName: referralSectionName });
            }, editorType: config.editorType, showUserActionNotification: showUserActionNotification, referralInfo: getReferralInfo(marketplaceStore.route && marketplaceStore.route.referral), unInstallApp: unInstallApp, openApp: openApp, deepLinkData: {
                appId: manageAppsDeepLinkData && manageAppsDeepLinkData.appId,
                modal: manageAppsDeepLinkData && manageAppsDeepLinkData.modal,
            }, hideBusinessSolutions: marketplaceStore.hideBusinessSolutionsInManageApps, geo: countryCode, goToHolidaySaleCategoryPage: function () {
                biLogger.appMarketSaleCheckAllSaleAppsHeaderClick({
                    msid: marketplaceStore.metaSiteId,
                    sale_name: 'nov21',
                    slug_id: 'pre-holiday-sale',
                    referral_tag_type: 'manage-apps',
                    market: config.originForBI,
                });
                config.goto({
                    path: Path.CATEGORY,
                    slug: 'pre-holiday-sale',
                    referral: 'holiday-sale-manage-apps',
                });
            } })));
});
//# sourceMappingURL=manage-apps.js.map